/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';
import styles from './CircledCrossIcon.style';

import svg from './circled-cross.svg';

type Props = {
  className?: string,
  title?: string,
  large?: boolean,
  // Self passed
};

const useStyles = createUseStyles(styles);

const CircledCrossIcon = ({ className, title, large }: Props): React.Node => {
  const classes: Object = useStyles();

  // Classes

  const rootClasses = classNames(classes.root, className, {
    [classes['root-large']]: large,
  });

  return <BaseIcon className={rootClasses} svg={svg} title={title} />;
};

export default compose(React.memo)(CircledCrossIcon);
